import { lazyNamed } from '../../../../helpers/lazyWithRetry';

/** Notice pages that open in full screen, outside the Hive header and tabs. */
export const ReportTemplateEditor = lazyNamed(
  () => import(/* webpackChunkName: "hive" */ './ReportTemplate'),
  'ReportTemplateEditor'
);

export const DistributionSimulator = lazyNamed(
  () => import(/* webpackChunkName: "hive" */ './DistributionSimulator'),
  'DistributionSimulator'
);
